import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';

import {
  createMAIroQuestionnaireAnswerSchema,
} from '../../../../utils/validators/MAIroValidators';

import type {
  TCreateMAIroQuestionnaireAnswerSchema,
} from '../../../../utils/validators/MAIroValidators';

const useMAIROQuestionsForm = () => {
  const {
    control,
    handleSubmit,
    setError,
    reset,
    setValue,
    watch,
  } = useForm<TCreateMAIroQuestionnaireAnswerSchema>({
    mode: 'onChange',
    resolver: yupResolver(createMAIroQuestionnaireAnswerSchema),
  });

  return {
    control,
    handleSubmit,
    setError,
    reset,
    setValue,
    watch,
  };
};

export default useMAIROQuestionsForm;
